import { c as _c } from "react/compiler-runtime";
import { passkeyClient } from "@better-auth/passkey/client";
import { ssoClient } from "@better-auth/sso/client";
import { deviceAuthorizationClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { useMemo } from "react";
import { useAppConfig } from "./config";

// React hook to get the auth client
export function useAuthClient() {
  const $ = _c(2);
  const config = useAppConfig();
  const t0 = config.apiUrl + "/auth";
  let t1;
  if ($[0] !== t0) {
    t1 = createAuthClient({
      baseURL: t0,
      plugins: [passkeyClient(), ssoClient(), deviceAuthorizationClient()]
    });
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}

// React hook for auth methods
export function useAuth() {
  const $ = _c(7);
  const authClient = useAuthClient();
  let t0;
  if ($[0] !== authClient.getSession || $[1] !== authClient.sendVerificationEmail || $[2] !== authClient.signIn || $[3] !== authClient.signOut || $[4] !== authClient.signUp || $[5] !== authClient.useSession) {
    t0 = {
      signIn: authClient.signIn,
      signUp: authClient.signUp,
      signOut: authClient.signOut,
      useSession: authClient.useSession,
      getSession: authClient.getSession,
      sendVerificationEmail: authClient.sendVerificationEmail
    };
    $[0] = authClient.getSession;
    $[1] = authClient.sendVerificationEmail;
    $[2] = authClient.signIn;
    $[3] = authClient.signOut;
    $[4] = authClient.signUp;
    $[5] = authClient.useSession;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  return t0;
}